<template>
  <div id="performancesTable">
    <v-data-table
      class="rmr-data-table"
      :headers="headers"
      :items="pagination.items"
      disable-sort
      disable-filtering
      :page="pagination.options.page"
      :pageCount="pagination.numberOfPages"
      :options.sync="pagination.options"
      :server-items-length="pagination.total"
      :loading="page.loading"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 250],
      }"
      :items-per-page="pagination.options.itemsPerPage"
    >
      <template v-slot:item.media_types="{ item }">
        <media-type-badge :media-types="item.media_types" />
      </template>
        <template v-slot:item.title="{ item }">
          <div class="truncateCell" :title="item.title">
            <a :href="item.url" target="_blank">
              {{ item.title }}
            </a>
          </div>
        </template>
        <template v-slot:item.from_entry="{ item }">
          <div class="originCell" :title="item.from_entry">
            {{ item.from_entry }}
          </div>
        </template>
        <template v-slot:item.description="{ item }">
          <div class="truncateCell" :title="item.description">
            {{ item.description }}
          </div>
        </template>
        <template v-slot:item.publication_date="{ item, index }">
          <div class="dateCell">
            {{ item.publication_date.date }}
            <br />
            {{ item.publication_date.time }}
          </div></template
        >
        <template v-slot:item.preview="{ item }">
          <img
            :src="item.preview.src"
            class="preview-img"
            v-if="item.preview && item.preview.src.length > 0 && !item.preview.error"
            @error="() => item.preview.error = true"
          />
        </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.truncateCell {
  width: 20rem;
  max-height: 5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  overflow-y: scroll;
}

.dateCell {
  width: 5rem;
  margin: auto;
  white-space: nowrap;
}

.originCell {
  width: 15rem;
  height: 2.5rem;
  overflow-x: scroll;
  white-space: nowrap;
  padding-bottom: 0.5rem;
}

.preview-img {
  max-width: 6rem;
  max-height: 3rem;
}
</style>

<script>
import { reactive, watch } from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useNewsRadarDataQuery from "@/components/news-radar/db/useNewsRadarDataQuery";
import MediaTypeBadge from "@/components/news-radar/db/parts/MediaTypeBadge.vue";

export default {
  name: "ResultsTable",
  components: { MediaTypeBadge },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { applyFilters, fetchPage, hasValidDates } = useNewsRadarDataQuery();

    const page = reactive({
      loading: false,
      forceCall: false,
      isOptionsInitialized: false,
    });

    const pagination = reactive({
      numberOfPages: 0,
      total: 0,
      items: [],
      options: {
        page: 1,
        itemsPerPage: 50,
      },
    });

    // =>  METHODS
    const checkDates = () => {
      if (!hasValidDates()) {
        alert("Sélectionnez une plage de date !");
        return false;
      }

      return true;
    };

    const formatData = (items) =>
      items.map((item) => {
        const matches = item.publication_date.match(
          /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/
        );

        return {
          ...item,
          preview: {
            src: item.preview,
            error: false,
          },
          source: item.news_radar_source.name,
          publication_date: {
            date: matches[1],
            time: matches[2],
            full: item.publication_date,
          },
        };
      });

    const getData = async () => {
      if ((applyFilters.value || page.forceCall) && !page.loading) {
        if (!checkDates()) {
          return;
        }

        try {
          page.loading = true;

          const { total, items } = await fetchPage({
            page: pagination.options.page,
            limit: pagination.options.itemsPerPage,
          });

          pagination.total = total;
          pagination.items = formatData(items);
        } catch (error) {
          console.error("error while fetching data");
        }

        page.loading = false;

        // Force clicking on button again to re-run that request :
        // (we don't call this dispatch earlier to be sure, as state is async, that all listening components could run their requests)
        store.dispatch("common/updateApplyFilters", false);
      }

      page.forceCall = false;
    };

    // =>  WATCH
    watch(applyFilters, async () => {
      await getData();
    });

    watch(
      () => pagination.options,
      () => {
        if (page.isOptionsInitialized) {
          // Not on initialization : wait for a real user change
          page.forceCall = true;
        }

        page.isOptionsInitialized = true;
        getData();
      }
    );

    // =>  HOOKS

    // =>  DATA
    return {
      page,
      pagination,
      headers: [
        {
          text: "Date de publication",
          value: "publication_date",
          width: "5rem",
          align: "center",
        },
        {
          text: "Visuel",
          value: "preview",
          width: "6rem",
          align: "center",
        },
        {
          text: "Support",
          value: "media_types",
          width: "6rem",
          align: "center",
        },
        {
          text: "Origine",
          value: "from_entry",
          width: "10rem",
        },
        {
          text: "Titre",
          value: "title",
          width: "20rem",
        },
        /* {
          text: "Lien",
          value: "url",
          width: "10rem",
        }, */
        {
          text: "Description",
          value: "description",
          width: "20rem",
        },
      ],
    };
  },
};
</script>
